
import React, { useState, useEffect } from "react";
import "./App.css";
import Routes from './Routes'
import InterventionPlanService from "./services/InterventionPlanService";


export default function App() {
  const [interventionPlans, setInterventionPlans] = useState([]);
  useEffect(() => {
    InterventionPlanService.getInterventionPlans(1).then((json) => {
      setInterventionPlans(json.data);
      console.log(json.data);
    });
  }, []);

  return (
    <Routes />
  );
}

